"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageFamilyOwnerMismatchError = exports.NonGlobalPackageInGlobalFamilyError = exports.FamilyChildOwnerConflictError = exports.PackageOwnerImmutableError = exports.FamilyAlreadyOwnedError = void 0;
exports.isFamilyAlreadyOwnedError = isFamilyAlreadyOwnedError;
exports.isFamilyChildOwnerConflictError = isFamilyChildOwnerConflictError;
exports.isPackageOwnerImmutableError = isPackageOwnerImmutableError;
exports.isNonGlobalPackageInGlobalFamilyError = isNonGlobalPackageInGlobalFamilyError;
exports.isPackageFamilyOwnerMismatchError = isPackageFamilyOwnerMismatchError;
const domain_errors_1 = require("../Auth/domain.errors");
class FamilyAlreadyOwnedError extends Error {
    constructor(packageFamilyId, currentOwnerId, requestedOwnerId) {
        super(`Package family ${packageFamilyId} is already owned by ${currentOwnerId}. ` +
            'Use --force (CLI) to override (this is an admin-only action).');
        this.name = this.constructor.name;
        this.packageFamilyId = packageFamilyId;
        this.currentOwnerId = currentOwnerId;
        this.requestedOwnerId = requestedOwnerId;
    }
}
exports.FamilyAlreadyOwnedError = FamilyAlreadyOwnedError;
class PackageOwnerImmutableError extends domain_errors_1.ValidationError {
    constructor(entityKind, entityId, persistedOwnerId, incomingOwnerId) {
        super(`Cannot change ownerId on ${entityKind} ${entityId} via update ` +
            `(persisted=${persistedOwnerId}, incoming=${incomingOwnerId}). ` +
            'Owner changes must go through packageFamily.assignOwner.');
        this.entityKind = entityKind;
        this.entityId = entityId;
        this.persistedOwnerId = persistedOwnerId;
        this.incomingOwnerId = incomingOwnerId;
    }
}
exports.PackageOwnerImmutableError = PackageOwnerImmutableError;
class FamilyChildOwnerConflictError extends Error {
    constructor(packageFamilyId, conflicts) {
        super(`Force reassignment refused because ${conflicts.length} child package(s) of family ${packageFamilyId} ` +
            'have third-party owners. Use --overwrite-conflicts to override.');
        this.name = this.constructor.name;
        this.packageFamilyId = packageFamilyId;
        this.conflicts = conflicts;
    }
}
exports.FamilyChildOwnerConflictError = FamilyChildOwnerConflictError;
class NonGlobalPackageInGlobalFamilyError extends Error {
    constructor(packageFamilyId, requestedOwnerId) {
        super(`Package family ${packageFamilyId} is globally shared, so a package owned by ` +
            `${requestedOwnerId} cannot be created in it. Choose the Global owner, or create ` +
            'the package in an organization-owned family.');
        this.name = this.constructor.name;
        this.packageFamilyId = packageFamilyId;
        this.requestedOwnerId = requestedOwnerId;
    }
}
exports.NonGlobalPackageInGlobalFamilyError = NonGlobalPackageInGlobalFamilyError;
class PackageFamilyOwnerMismatchError extends Error {
    constructor(packageFamilyId, requestedOwnerId, familyOwnerId) {
        super(`Package family ${packageFamilyId} is owned by ${familyOwnerId}, so a package owned by ` +
            `${requestedOwnerId} cannot be created in it. Packages inherit their family's owner; ` +
            'create the package in a family owned by the requested organization.');
        this.name = this.constructor.name;
        this.packageFamilyId = packageFamilyId;
        this.requestedOwnerId = requestedOwnerId;
        this.familyOwnerId = familyOwnerId;
    }
}
exports.PackageFamilyOwnerMismatchError = PackageFamilyOwnerMismatchError;
function isFamilyAlreadyOwnedError(error) {
    return error instanceof FamilyAlreadyOwnedError;
}
function isFamilyChildOwnerConflictError(error) {
    return error instanceof FamilyChildOwnerConflictError;
}
function isPackageOwnerImmutableError(error) {
    return error instanceof PackageOwnerImmutableError;
}
function isNonGlobalPackageInGlobalFamilyError(error) {
    return error instanceof NonGlobalPackageInGlobalFamilyError;
}
function isPackageFamilyOwnerMismatchError(error) {
    return error instanceof PackageFamilyOwnerMismatchError;
}
//# sourceMappingURL=package-ownership.errors.js.map